import * as React from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

const Input = React.forwardRef(({ className, type = "text", ...props }, ref) => {
  return (
    <input
      type={type}
      ref={ref}
      className={twMerge(clsx("flex h-10 w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm shadow-sm outline-none ring-offset-white placeholder:text-slate-400 focus:border-brand-orange focus:ring-2 focus:ring-brand-orange/20 disabled:cursor-not-allowed disabled:opacity-50", className))}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
